/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Modal, Segment, Form, Input, Select,
  Button, Divider, Dimmer, Loader, Icon, Header,
  Popup, Dropdown, Checkbox, Radio, FormField
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import UpdateLoader from "./UpdateLoader";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";
import sha256 from "js-sha256";
import Timezones from "../utilities/Timezones";

const UtilsInstance = new Utils();

const dropdownOptions = [
  {
    key: 1,
    value: 1,
    text: Strings.CHANNEL_1
  },
  {
    key: 2,
    value: 2,
    text: Strings.CHANNEL_2

  },
  {
    key: 3,
    value: 3,
    text: Strings.CHANNEL_3
  },
  {
    key: 4,
    value: 4,
    text: Strings.CHANNEL_4
  }
];

class Configuration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      // Channel Tags
      dropdownChannel: -1,
      tag: "",
      note: "",
      channelTagsAndNotes: [],
      // NTP
      ntpAddr: "",
      isNtpActive: false,
      ntpCheckboxLabel: Strings.WLAN_ADAPTER_OFF,
      timezone: "",
      isNtpDimmerActive: false,
      ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED,
      // Others
      openFile: false,
      isStartStopDimmerActive: false,
      isDimmerActive: false,
      isRestartSystemModalOpen: false,
      isUpdateDimmerActive: false,
      updateStatus: Constants.NOT_UPDATING,
      isTagConfigDimmerActive: false,
      scopeTag: "",
      // Clear log
      isResetLogDimmerActive: false,
      isChannel1LogChecked: false,
      isChannel2LogChecked: false,
      isChannel3LogChecked: false,
      isChannel4LogChecked: false,
      WifiAdapterDetected: false,
    };
    this.updateLoaderRef = React.createRef();
  }

  showDimmer = () => this.setState({ isDimmerActive: true });
  hideDimmer = () => this.setState({ isDimmerActive: false });

  showRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: true });
  hideRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: false });

  showUpdateDimmer = () => this.setState({ isUpdateDimmerActive: true });
  hideUpdateDimmer = () => this.setState({ isUpdateDimmerActive: false });

  showNtpDimmer = () => this.setState({ isNtpDimmerActive: true });
  hideNtpDimmer = () => this.setState({ isNtpDimmerActive: false });

  showNtpModal = () => this.setState({ isNtpModalOpen: true });
  hideNtpModal = () => this.setState({ isNtpModalOpen: false });

  showTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: true });
  hideTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: false });

  // verificaWLAN = async () => {

  //   let WifiAdapterDetected = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiOnUsb", { mode: "cors" })
  //     .then(res => res.json())
  //     .then(data => data.wifiOnUsb);

  //   this.setState({WifiAdapterDetected: WifiAdapterDetected});
  // }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "ntp", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "getChannelTagsAndNotes/1", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "getChannelTagsAndNotes/2", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "getChannelTagsAndNotes/3", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "getChannelTagsAndNotes/4", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "wifiOnUsb", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.wifiOnUsb)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    let channelTagsAndNotes = [];
    resolvedPromisses[2].channel = parseInt(resolvedPromisses[2].channel);
    resolvedPromisses[3].channel = parseInt(resolvedPromisses[3].channel);
    resolvedPromisses[4].channel = parseInt(resolvedPromisses[4].channel);
    resolvedPromisses[5].channel = parseInt(resolvedPromisses[5].channel);
    channelTagsAndNotes.push(resolvedPromisses[2]);
    channelTagsAndNotes.push(resolvedPromisses[3]);
    channelTagsAndNotes.push(resolvedPromisses[4]);
    channelTagsAndNotes.push(resolvedPromisses[5]);

    this.setState({
      ntpAddr: resolvedPromisses[0].ntpIp,
      isNtpActive: resolvedPromisses[0].ntp,
      timezone: resolvedPromisses[0].timezone,
      channelTagsAndNotes: channelTagsAndNotes,
      ntpCheckboxLabel: resolvedPromisses[0].ntp ? Strings.WLAN_ADAPTER_ON : Strings.WLAN_ADAPTER_OFF,
      scopeTag: resolvedPromisses[1].tag,
      WifiAdapterDetected: resolvedPromisses[6],
    });
  }

  //Sends a .gpg file to the server to update the scope pa software
  sendFile = () => {
    let input = document.getElementById("send-gpg-input");
    // If the file exists and doesn't contain ".gpg" in its name
    if (input.files[0] !== undefined && input.files[0] !== null) {
      if (input.files[0].name.indexOf(Strings.GPG_FILE_EXTENSION) === -1) {
        alert(Strings.GPG_ALERT_MESSAGE);
      }
      else {
        let data = new FormData();
        let reader = new FileReader();
        let sha256Checksum = "";

        reader.onload = (event) => {
          sha256Checksum = sha256(event.target.result);

          data.append("updateFile", input.files[0]);
          data.append("checkSum", sha256Checksum);

          this.showDimmer();

          fetch(Constants.REQUEST_IP_ADDRESS + "sendFile_POST", {
            method: "POST",
            body: data
          })
            .then(UtilsInstance.checkStatus)
            .then(() => {
              this.handleUpdateCycles(Constants.FILE_UPDATE_TYPE);
            })
            .catch((error) => {
              if (error.response.status === 415) {
                alert(Strings.SEND_FILE_FAILURE + Strings.ERROR_REASON + Strings.SEND_FILE_WRONG_FILENAME);
              }
              else if (error.response.status === 417) {
                alert(Strings.SEND_FILE_FAILURE + Strings.ERROR_REASON + Strings.SEND_FILE_CORRUPTED_FILE);
              }
              else {
                alert(Strings.SEND_FILE_FAILURE + Strings.ERROR_REASON + error);
              }

            })
            .finally(this.hideDimmer);
        };

        reader.onerror = (event) => {
          reader.abort();
          alert(Strings.SEND_FILE_FAILURE + Strings.ERROR_REASON + event);
        };

        reader.readAsArrayBuffer(input.files[0]);
      }
    }
    else {
      alert(Strings.SELECT_FILE);
    }
  }

  logOut = () => {
    sessionStorage.removeItem("auth");
    this.props.history.push({ pathname: "/login-handler" });
  }

  generateReport = () => {
    this.props.history.push({ pathname: "/report" });
  }

  openEthernetPage = () => {
    this.props.history.push({ pathname: "/ethernet-config" });
  }

  openWLANPage = () => {
    this.props.history.push({ pathname: "/wlan-config" });
  }

  openTsExpertPage = () => {
    this.props.history.push({ pathname: "/ts-expert-config" });
  }

  openActiveChannelsPage = () => {
    this.props.history.push({ pathname: "/active-channels" });
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  changeLoginInfo = () => {
    this.props.history.push({ pathname: "/change-login" });
  }

  alterTags = () => {
    this.props.history.push({ pathname: "/tags" });
  }

  handleRestartSystemModalPositiveClick = () => {
    let data = JSON.stringify({ reset: "True" });

    fetch(Constants.REQUEST_IP_ADDRESS + "restartSystem_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.RESTART_SYSTEM_SUCCESS);
      })
      .catch(function (error) {
        alert(Strings.RESTART_SYSTEM_FAILURE + Strings.ERROR_REASON + error);
      })
      .finally(this.hideRestartSystemModal);
  }

  handleUpdateCycles = (updateType) => {
    this.showUpdateDimmer();
    let intervalID = -1;

    if (updateType === Constants.FILE_UPDATE_TYPE) {
      intervalID = setInterval(this.handleUpdateStatus, 2000);
    }
    else if (updateType === Constants.NTP_UPDATE_TYPE) {
      intervalID = setInterval(this.handleUpdateNtpStatus, 2000);
    }

    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.UPDATE_FILES_FOUND) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.UPDATING_MONITOR_FILES);
          });
        }
        else if (this.state.updateStatus === Constants.UPDATE_FILES_FOUND && data.update === Constants.FINISHED_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.MONITOR_FILES_UPDATED_SUCCESSFULLY);
          });
        }
        else if (this.state.updateStatus === Constants.FINISHED_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText("");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.UPDATE_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.UPDATE_ERROR_STRING + error);
      });
  }

  handleUpdateNtpStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText("");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.MONITOR_RESTART_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.MONITOR_RESTART_FAILURE + error);
      });
  }

  handleChannelDropdownChange = (event, info) => {
    this.retrieveData();
    this.setState({ dropdownChannel: info.value }, () => {
      for (let i = 0; i < this.state.channelTagsAndNotes.length; i++) {
        if (this.state.channelTagsAndNotes[i].channel === this.state.dropdownChannel) {
          let tag = "";
          let note = "";

          if (this.state.channelTagsAndNotes[i].tag !== null) {
            tag = this.state.channelTagsAndNotes[i].tag;
          }

          if (this.state.channelTagsAndNotes[i].note !== null) {
            note = this.state.channelTagsAndNotes[i].note;
          }

          this.setState({
            tag: tag,
            note: note
          });
        }
      }
    });
  }

  handleTagChange = (e, { value }) => {
    this.setState({ tag: value });
  }

  handleNoteChange = (e, { value }) => {
    if (value.length <= Constants.MAX_NOTE_LENGTH) {
      this.setState({ note: value });
    }
  }

  handleTagAndNoteSubmit = () => {
    if (this.state.dropdownChannel === -1) {
      alert(Strings.CHOOSE_A_CHANNEL);
    }
    else if (this.state.tag.length > 30) {
      alert(Strings.TAG_TOO_LONG);
    }
    else {

      let data = JSON.stringify({
        "channel": this.state.dropdownChannel,
        "tag": this.state.tag,
        "note": this.state.note
      });

      fetch(Constants.REQUEST_IP_ADDRESS + "setChannelTagAndNote_POST/" + this.state.dropdownChannel, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data,
        mode: "cors"
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.TAG_AND_NOTE_FROM_CHANNEL + this.state.dropdownChannel + Strings.WAS_SUCCESSFULLY_ALTERED);

          // fetch(Constants.REQUEST_IP_ADDRESS + "getChannelTagsAndNotes/" + this.state.dropdownChannel, { mode: "cors" })
          //   .then(res => res.json())
          //   .then(data => this.setState({ channelTagsAndNotes: data }));

        })
        .catch((error) => {
          alert(Strings.ALTER_TAG_ERROR + this.state.dropdownChannel + Strings.ALTER_TAG_ERROR_REASON + error);
        });
    }
  }

  // ----------------------- NTP ---------------------------
  handleNTPAddressChange = (e, { value }) => {
    this.setState({ ntpAddr: value });
  }

  toggleNtpActive = () => {
    this.setState({
      ntpCheckboxLabel: !this.state.isNtpActive ? Strings.WLAN_ADAPTER_ON : Strings.WLAN_ADAPTER_OFF,
      isNtpActive: !this.state.isNtpActive
    });
  }

  handleTurnNtpServerOnModalPositiveClick = () => {
    this.hideNtpModal();
    this.updateNtpServer();
  }

  saveNtpServerInfo = () => {
    let isIpValid = UtilsInstance.validateIPAddress(this.state.ntpAddr);
    let isIPLoopback = UtilsInstance.isIPLoopback(this.state.ntpAddr);

    // Verify the network information provided. Only send it if it passes the validation
    if (!isIpValid || isIPLoopback || this.state.timezone.length === 0) {
      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      // If the IP is not valid or if it is the loopback IP (127.0.0.1)
      if (!isIpValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_IP);
      }
      else if (isIPLoopback) {
        invalidInformationString = invalidInformationString.concat(Strings.LOOPBACK_IP_NTP);
      }

      if (this.state.timezone.length === 0) {
        invalidInformationString = invalidInformationString.concat(Strings.SELECT_TIMEZONE);
      }

      alert(invalidInformationString);
    }
    else {
      this.showNtpModal();
    }
  }

  updateNtpServer = () => {
    let data = JSON.stringify({
      ntp: this.state.isNtpActive,
      ntpIp: this.state.ntpAddr,
      timezone: this.state.timezone
    });

    let errorMessage = "";

    if (this.state.isNtpActive === false) {
      errorMessage = Strings.NTP_INFO_TURNED_OFF_FAILURE;
    }
    else {
      errorMessage = Strings.NTP_INFO_TURNED_ON_FAILURE;
    }

    this.showNtpDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "ntp_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus)
      //.then(res => res.json())
      .then(() => {
        this.updateNtpServerFirstStep();
      })
      .catch((error) => {
        this.toggleNtpActive();
        console.log(error);
        alert(errorMessage + Strings.ERROR_REASON + Strings.NTP_INFO_FAILURE);
      })
      .finally(this.hideNtpDimmer);
  }

  updateNtpServerFirstStep = () => {
    let intervalID = -1;
    this.showUpdateDimmer();
    this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INIT, "");
    intervalID = setInterval(this.handleUpdateNtpFirstStep, 2000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateNtpFirstStep = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "ntpUpdate", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.ntpUpdate);
        console.log("Data update Status: ", data.ntpUpdate);

        if (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED && data.ntpUpdate === Constants.NTP_UPDATE_START) {
          this.setState({ ntpUpdate: data.ntpUpdate }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INFO, "");
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_SUCCESS
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSED_NTP_INFO, "");
            clearInterval(this.state.intervalID);
            this.handleUpdateCycles(Constants.NTP_UPDATE_TYPE);
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_FAIL
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.PROCESSING_NTP_ERROR);
            this.toggleNtpActive();
          });
        }
      })
      .catch(() => {
        this.hideUpdateDimmer();
        clearInterval(this.state.intervalID);
        this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED });
        alert(Strings.PROCESSING_NTP_ERROR);
        this.toggleNtpActive();
      });
  }


  onTimezoneDropdownChange = (e, { value }) => this.setState({ timezone: value })

  // ----------------------- Channels ---------------------------
  sendTag = () => {
    this.showTagConfigDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "tag_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ tag: this.state.scopeTag })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TAG_WAS_CHANGED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TAG_CHANGE_FAILURE + "\n" + Strings.REASON_PA + error);
      })
      .finally(this.hideTagConfigDimmer);
  }

  handleScopeTagChange = (e, { value }) => {
    this.setState({ scopeTag: value });
  }

  // ----------------------- Clear log ---------------------------
  showResetLogDimmer = () => this.setState({ isResetLogDimmerActive: true });
  hideResetLogDimmer = () => this.setState({ isResetLogDimmerActive: false });

  toggleActiveChannel = (channel) => {
    if (channel === 1) {
      this.setState({
        isChannel1LogChecked: true,
        isChannel2LogChecked: false,
        isChannel3LogChecked: false,
        isChannel4LogChecked: false,
      });
    }
    else if (channel === 2) {
      this.setState({
        isChannel1LogChecked: false,
        isChannel2LogChecked: true,
        isChannel3LogChecked: false,
        isChannel4LogChecked: false,
      });
    }
    else if (channel === 3) {
      this.setState({
        isChannel1LogChecked: false,
        isChannel2LogChecked: false,
        isChannel3LogChecked: true,
        isChannel4LogChecked: false,
      });
    }
    else if (channel === 4) {
      this.setState({
        isChannel1LogChecked: false,
        isChannel2LogChecked: false,
        isChannel3LogChecked: false,
        isChannel4LogChecked: true,
      });
    }
  }

  cleanLog = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    if (this.state.isChannel1LogChecked) {
      this.showResetLogDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "resetLog_POST/1", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      }).then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.CLEAN_LOG_SUCCESS_1 + 1 + Strings.CLEAN_LOG_SUCCESS_2);
        })
        .catch((error) => {
          alert(Strings.CLEAN_LOG_FAILURE + "\n" + Strings.REASON_PA + error);
        })
        .finally(this.hideResetLogDimmer);
    }
    else if (this.state.isChannel2LogChecked) {
      this.showResetLogDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "resetLog_POST/2", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      }).then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.CLEAN_LOG_SUCCESS_1 + 2 + Strings.CLEAN_LOG_SUCCESS_2);
        })
        .catch((error) => {
          alert(Strings.CLEAN_LOG_FAILURE + "\n" + Strings.REASON_PA + error);
        })
        .finally(this.hideResetLogDimmer);
    }
    else if (this.state.isChannel3LogChecked) {
      this.showResetLogDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "resetLog_POST/3", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      }).then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.CLEAN_LOG_SUCCESS_1 + 3 + Strings.CLEAN_LOG_SUCCESS_2);
        })
        .catch((error) => {
          alert(Strings.CLEAN_LOG_FAILURE + "\n" + Strings.REASON_PA + error);
        })
        .finally(this.hideResetLogDimmer);
    }
    else if (this.state.isChannel4LogChecked) {
      this.showResetLogDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "resetLog_POST/4", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      }).then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.CLEAN_LOG_SUCCESS_1 + 4 + Strings.CLEAN_LOG_SUCCESS_2);
        })
        .catch((error) => {
          alert(Strings.CLEAN_LOG_FAILURE + "\n" + Strings.REASON_PA + error);
        })
        .finally(this.hideResetLogDimmer);
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
    // Inicia o loop para verificar a WLAN a cada 5 segundos (5000 ms)
    // this.wlanInterval = setInterval(this.verificaWLAN, 5000);
  }

  // componentWillUnmount() {
  //   // Limpa o intervalo quando o componente é desmontado para evitar chamadas de rede desnecessárias
  //   clearInterval(this.wlanInterval);
  // }

  render() {
    const isDimmerActive = this.state.isDimmerActive;
    const isUpdateDimmerActive = this.state.isUpdateDimmerActive;
    const isNtpDimmerActive = this.state.isNtpDimmerActive;
    const isTagConfigDimmerActive = this.state.isTagConfigDimmerActive;

    return (
      <div style={configStyle} >
        <p id="demo"></p>
        <div style={logoutButtonContainer}>
          <Button
            icon
            style={logoutButtonStyle}
            color="red"
            onClick={this.showRestartSystemModal}>
            <Icon name='power off' />
            {Strings.RESTART_SYSTEM}
          </Button>
          <Button style={logoutButtonStyle} color="grey" onClick={this.logOut}>{Strings.LOGOUT}</Button>
        </div>

        <Grid columns={2} doubling>
          <Grid.Column>

            <Grid columns={2} doubling>
              <Grid.Column>

                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>
                    {Strings.ACTIVE_CHANNELS}
                    <Popup position='bottom center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        <p>{Strings.ACTIVE_CHANNELS_POPUP_1}</p>
                        <p>{Strings.ACTIVE_CHANNELS_POPUP_2}</p>
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openActiveChannelsPage} />
                </Segment>

                <Segment>
                  <Divider horizontal>{Strings.TAG_PA}</Divider>
                  <Form style={formStyle} onSubmit={this.sendTag}>

                    <Form.Field inline>
                      <label style={labelStyle}>{Strings.TAG}</label>
                      <Input style={inputStyle}
                        placeholder="Tag"
                        value={this.state.scopeTag}
                        onChange={this.handleScopeTagChange} />
                    </Form.Field>

                    <Button color="teal" type="submit" >{Strings.SETUP}</Button>
                  </Form>
                  <Dimmer active={isTagConfigDimmerActive} >
                    <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
                  </Dimmer>
                </Segment>

                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>
                    {Strings.TS_EXPERT}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {Strings.TS_EXPERT_CONFIG_POPUP}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button color="teal" onClick={this.openTsExpertPage}>{Strings.SETUP}</Button>
                </Segment>

                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.LOG}</Divider>

                  <Grid columns={2}>
                    <Grid.Row>
                      <Grid.Column>
                        <Form>
                          <FormField style={{ marginBottom: "0vh" }}>
                            <Radio
                              onClick={() => this.toggleActiveChannel(1)}
                              label={Strings.CHANNEL_1}
                              checked={this.state.isChannel1LogChecked} />
                          </FormField>
                          <FormField>
                            <Radio
                              onClick={() => this.toggleActiveChannel(2)}
                              label={Strings.CHANNEL_2}
                              checked={this.state.isChannel2LogChecked} />
                          </FormField>
                        </Form>
                      </Grid.Column>
                      <Grid.Column>
                        <Form>
                          <FormField style={{ marginBottom: "0vh" }}>
                            <Radio
                              onClick={() => this.toggleActiveChannel(3)}
                              label={Strings.CHANNEL_3}
                              checked={this.state.isChannel3LogChecked} />
                          </FormField>
                          <FormField>
                            <Radio
                              onClick={() => this.toggleActiveChannel(4)}
                              label={Strings.CHANNEL_4}
                              checked={this.state.isChannel4LogChecked} />
                          </FormField>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>

                  <Button color="teal" onClick={this.cleanLog}>{Strings.CLEAR}</Button>
                  <Dimmer active={this.state.isResetLogDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>

              </Grid.Column>

              <Grid.Column>

                <Segment>
                  <Divider horizontal>{Strings.CHANNELS_TAGS}</Divider>

                  <Form style={formStyle} onSubmit={this.handleTagAndNoteSubmit}>

                    <Form.Field inline>
                      <label style={labelStyle}>{Strings.CHANNELS}</label>
                      <Select
                        style={inputStyle}
                        placeholder={Strings.CHANNELS}
                        options={dropdownOptions}
                        onChange={this.handleChannelDropdownChange} />
                    </Form.Field>

                    <Form.Field inline>
                      <label style={labelStyle}>{Strings.TAG}</label>
                      <Input style={inputStyle}
                        placeholder={Strings.TAG_CHANNELS}
                        value={this.state.tag}
                        onChange={this.handleTagChange} />
                    </Form.Field>

                    {/* <Form.Field inline>
                  <label style={labelStyle}>{Strings.NOTE}</label>
                  <TextArea style={inputStyle}
                    placeholder={Strings.NOTE}
                    value={this.state.note}
                    rows={4}
                    onChange={this.handleNoteChange} />
                </Form.Field> */}

                    <Button color="teal" type="submit" >{Strings.SAVE}</Button>
                  </Form>

                </Segment>

                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.DEVICES_TAGS}</Divider>
                  <Button color="teal" onClick={this.alterTags}>{Strings.EDIT}</Button>
                </Segment>

              </Grid.Column>
            </Grid>

          </Grid.Column>

          <Grid.Column>

            <Segment style={updateSegmentStyle}>
              <Divider horizontal>{Strings.SOFTWARE_UPDATE}</Divider>
              <p>{Strings.CURRENT_VERSION}<b>{Constants.SOFTWARE_VERSION}</b></p>
              <Form style={formStyle} onSubmit={this.sendFile}>
                <Form.Input id="send-gpg-input" type="file" accept=".gpg"></Form.Input>
                <Button color="teal" type="submit" >{Strings.UPDATE}</Button>
              </Form>
              <Dimmer active={isDimmerActive} >
                <Loader>{Strings.SEND_FILE_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment textAlign="center">
              <Divider horizontal>{Strings.NTP_SERVER}</Divider>

              <Form onSubmit={this.saveNtpServerInfo}>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "1vh" }}>
                  <div style={{ flexGrow: 2 }}>
                    <Form.Field>
                      <label>{Strings.IP}</label>
                      <Input
                        fluid
                        placeholder="192.168.0.2"
                        value={this.state.ntpAddr}
                        onChange={this.handleNTPAddressChange} />
                    </Form.Field>

                    <Form.Field>
                      <label>Timezone</label>
                      <Dropdown
                        fluid
                        placeholder="Timezone"
                        search
                        selection
                        scrolling
                        options={Timezones.zones}
                        value={this.state.timezone}
                        onChange={this.onTimezoneDropdownChange} />
                    </Form.Field>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <Form.Field>
                      <Checkbox
                        toggle
                        onClick={this.toggleNtpActive}
                        checked={this.state.isNtpActive}
                        label={this.state.ntpCheckboxLabel} />
                    </Form.Field>
                  </div>
                </div>

                <Button color="teal" type="submit">{Strings.SETUP}</Button>
              </Form>

              <Dimmer active={isNtpDimmerActive} >
                <Loader>{Strings.SEND_NTP_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Grid columns={2} doubling>
              <Grid.Column>

                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>
                    {Strings.ETHERNET}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        <p>{Strings.ETHERNET_POPUP_1}</p>
                        <p>{Strings.ETHERNET_POPUP_2}</p>
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openEthernetPage} />
                </Segment>

                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.REPORT}</Divider>
                  <Button color="teal" onClick={this.generateReport}>{Strings.GENERATE_REPORT}</Button>
                </Segment>

              </Grid.Column>

              <Grid.Column>

                {this.state.WifiAdapterDetected === true && (
                  <Segment style={updateSegmentStyle}>
                    <Divider horizontal>
                      {Strings.WLAN}
                      <Popup position='top center' hoverable pinned wide="very"
                        trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                        <Popup.Content>
                          <p>{Strings.WLAN_POPUP_1}</p>
                          <p>{Strings.WLAN_POPUP_2}</p>
                        </Popup.Content>
                      </Popup>
                    </Divider>
                    <Button
                      content={Strings.SETUP}
                      color="teal"
                      onClick={this.openWLANPage} />
                  </Segment>
                )}

                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.ALTER_LOGIN}</Divider>
                  <Button color="teal" onClick={this.changeLoginInfo}>{Strings.ALTER}</Button>
                </Segment>

              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid>

        <Modal basic size='small' open={this.state.isNtpModalOpen}>
          <Header
            icon='power'
            content={
              this.state.isNtpActive ? Strings.TURN_NTP_SERVER_ON: Strings.TURN_NTP_SERVER_OFF
            }
          />
          <Modal.Content>
            <p>{
              this.state.isNtpActive ? Strings.TURN_NTP_SERVER_ON_QUESTION : Strings.TURN_NTP_SERVER_OFF_QUESTION
            }</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.hideNtpModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleTurnNtpServerOnModalPositiveClick}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='small' open={this.state.isRestartSystemModalOpen}>
          <Header icon='history' content={Strings.RESTART_SYSTEM} />
          <Modal.Content>
            <p>{Strings.CONFIRM_RESTART_SYSTEM}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={this.hideRestartSystemModal}><Icon name='remove' />{Strings.NO}</Button>
            <Button color='green' onClick={this.handleRestartSystemModalPositiveClick}><Icon name='checkmark' />{Strings.YES}</Button>
          </Modal.Actions>
        </Modal>

        <Dimmer page active={isUpdateDimmerActive}>
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer>
      </div >
    );
  }
}

const configStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const updateSegmentStyle = {
  textAlign: "center"
};

const labelStyle = {
  width: "20%"
};

const inputStyle = {
  width: "70%"
};

const logoutButtonContainer = {
  textAlign: "right"
};

const logoutButtonStyle = {
  marginBottom: "1em"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(Configuration);